/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Explorer_Nav_SearchInputs */

const en_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const fr_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const de_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const it_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const ru_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const es_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const zh_cn2_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const ja_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const hi_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

const pt_pt2_explorer_nav_search = /** @type {(inputs: Explorer_Nav_SearchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search`)
};

/**
* | output |
* | --- |
* | "Search" |
*
* @param {Explorer_Nav_SearchInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const explorer_nav_search = /** @type {((inputs?: Explorer_Nav_SearchInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Explorer_Nav_SearchInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_explorer_nav_search(inputs)
	if (locale === "de") return de_explorer_nav_search(inputs)
	if (locale === "it") return it_explorer_nav_search(inputs)
	if (locale === "ru") return ru_explorer_nav_search(inputs)
	if (locale === "es") return es_explorer_nav_search(inputs)
	if (locale === "zh-CN") return zh_cn2_explorer_nav_search(inputs)
	if (locale === "ja") return ja_explorer_nav_search(inputs)
	if (locale === "hi") return hi_explorer_nav_search(inputs)
	if (locale === "pt-PT") return pt_pt2_explorer_nav_search(inputs)
	return en_explorer_nav_search(inputs)
});